// src/store/Slices/spotTradingSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../API/api';

export const fetchTradeHistory = createAsyncThunk('spotTrading/fetchTradeHistory', async (userId, { rejectWithValue }) => {
  try {
    if (!userId) {
      throw new Error('userId غير متوفر');
    }
    console.log('جلب سجل الصفقات للمستخدم:', userId);
    const response = await api.get(`/spot/history/${userId}`, { timeout: 10000 });
    console.log('تم جلب سجل الصفقات:', response.data);
    return response.data;
  } catch (error) {
    console.error('خطأ في جلب سجل الصفقات:', error.message);
    return rejectWithValue(error.response?.data?.message || error.message || 'فشل جلب سجل الصفقات');
  }
});

export const fetchOpenOrders = createAsyncThunk('spotTrading/fetchOpenOrders', async (userId, { rejectWithValue }) => {
  try {
    if (!userId) {
      throw new Error('userId غير متوفر');
    }
    console.log('جلب الأوامر المفتوحة للمستخدم:', userId);
    const response = await api.get(`/spot/open-orders/${userId}`, { timeout: 10000 });
    console.log('تم جلب الأوامر المفتوحة:', response.data);
    return response.data;
  } catch (error) {
    console.error('خطأ في جلب الأوامر المفتوحة:', error.message);
    return rejectWithValue(error.response?.data?.message || error.message || 'فشل جلب الأوامر المفتوحة');
  }
});

export const cancelSpotTrade = createAsyncThunk('spotTrading/cancelSpotTrade', async (tradeId, { rejectWithValue, dispatch }) => {
  try {
    console.log('إلغاء صفقة فورية:', tradeId);
    const response = await api.put(`/spot/trade/${tradeId}/cancel`, {}, { timeout: 10000 });
    console.log('تم إلغاء الصفقة الفورية:', response.data);
    // إعادة جلب الأوامر المفتوحة بعد الإلغاء لتحديث القائمة
    dispatch(fetchOpenOrders(response.data.user_id));
    return response.data;
  } catch (error) {
    console.error('خطأ في إلغاء الأمر:', error.message);
    return rejectWithValue(error.response?.data?.message || error.message || 'فشل إلغاء الأمر');
  }
});

const spotTradingSlice = createSlice({
  name: 'spotTrading',
  initialState: {
    selectedCoin: null,
    tradeHistory: [],
    openOrders: [],
    tradeHistoryLoading: false,
    openOrdersLoading: false,
    error: null,
  },
  reducers: {
    setSelectedCoin: (state, action) => {
      state.selectedCoin = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTradeHistory.pending, (state) => {
        console.log('fetchTradeHistory قيد الانتظار');
        state.tradeHistoryLoading = true;
        state.error = null;
      })
      .addCase(fetchTradeHistory.fulfilled, (state, action) => {
        console.log('fetchTradeHistory نجح', action.payload);
        state.tradeHistoryLoading = false;
        state.tradeHistory = action.payload;
      })
      .addCase(fetchTradeHistory.rejected, (state, action) => {
        console.log('fetchTradeHistory فشل', action.payload);
        state.tradeHistoryLoading = false;
        state.error = action.payload || 'فشل جلب سجل الصفقات';
      })
      .addCase(fetchOpenOrders.pending, (state) => {
        console.log('fetchOpenOrders قيد الانتظار');
        state.openOrdersLoading = true;
        state.error = null;
      })
      .addCase(fetchOpenOrders.fulfilled, (state, action) => {
        console.log('fetchOpenOrders نجح', action.payload);
        state.openOrdersLoading = false;
        state.openOrders = action.payload;
      })
      .addCase(fetchOpenOrders.rejected, (state, action) => {
        console.log('fetchOpenOrders فشل', action.payload);
        state.openOrdersLoading = false;
        state.error = action.payload || 'فشل جلب الأوامر المفتوحة';
      })
      .addCase(cancelSpotTrade.pending, (state) => {
        console.log('cancelSpotTrade قيد الانتظار');
        state.error = null;
      })
      .addCase(cancelSpotTrade.fulfilled, (state, action) => {
        console.log('cancelSpotTrade نجح', action.payload);
        state.error = null;
        // الأوامر المفتوحة ستُحدث تلقائيًا بفضل fetchOpenOrders في cancelSpotTrade
      })
      .addCase(cancelSpotTrade.rejected, (state, action) => {
        console.log('cancelSpotTrade فشل', action.payload);
        state.error = action.payload || 'فشل إلغاء الأمر';
      });
  },
});

export const { setSelectedCoin } = spotTradingSlice.actions;
export default spotTradingSlice.reducer;